import React from "react";
import { buildFullLink } from "common/routing";
import { arrayHasExactlyOneItem } from "common/utils/arrays";
import { getAppPrefix } from "common/utils/url";
import { GetUserAccountsQuery } from "../../generated/graphql";
import { usePrevLocationParamParser } from "../../utils/params";
import { FlexRow } from "../Common/__styles__/Layout";
import { AccountLogoOrFallbackIcon } from "../Common/AccountLogo";
import { Icon } from "../Common/Icons/LucideIcons";
import { CommonContentIconWrapper } from "../Inputs/__styles__/SelectionCard";
import { SelectionCard } from "../Inputs/SelectionCard";
import NavigationCard from "./CommonLoginComponents/NavigationCard";

export const ProvideCredentialsNavigationCard = ({
  accounts,
  currentAccount,
  email,
}: {
  accounts: NonNullable<GetUserAccountsQuery["getUserAccountsByEmail"]>;
  currentAccount: NonNullable<
    GetUserAccountsQuery["getUserAccountsByEmail"]
  >[0];
  email: string;
}) => {
  const prev = usePrevLocationParamParser("provideCredentials");
  const prefix = getAppPrefix();

  const backUrl = buildFullLink("login", {
    params: {},
    queryParams: {
      prev,
      //We omit the email when there is only one account because otherwise we would immediately redirect them back to this Provide Credentials page
      ...(arrayHasExactlyOneItem(accounts) ? {} : { email }),
    },
    prefix,
  });

  if (arrayHasExactlyOneItem(accounts)) {
    return (
      <NavigationCard
        onClick={() => {
          window.location.href = backUrl;
        }}
      >
        <SelectionCard.CommonContent iconName="chevron-left" title={email} />
      </NavigationCard>
    );
  }

  return (
    <NavigationCard
      onClick={() => {
        window.location.href = backUrl;
      }}
    >
      <FlexRow gap="s" style={{ alignItems: "center" }}>
        <CommonContentIconWrapper>
          <Icon iconName="chevron-left" color={"contentSecondary"} size={16} />
        </CommonContentIconWrapper>
        <AccountLogoOrFallbackIcon size={32} account={currentAccount} />
        <SelectionCard.CommonContent title={currentAccount.name} />
      </FlexRow>
    </NavigationCard>
  );
};
